import * as React from "react";
import Box from "@mui/material/Box";
import {
  Backdrop,
  CircularProgress,
  Collapse,
  Stack,
  Typography,
} from "@mui/material";
import CorporateCategoryCardList from "./CardCorporateCategory";
import BreadCrumbs from "../../../components/navbar/BreadCrumb";
import SearchBar from "../../../components/ui/SearchBar";
import LoaderImg from "../../../components/ui/loader";
import { TransitionGroup } from "react-transition-group";
import axiosErrorHandler from "../../../ErrorHandler/axiosErrHandler";
import { allCorporateList } from "../../../APIConfig/NewCorporateApiConfig";


// corporate list for shwoing all corporate scenario list
export default function NewCategoryPageCorporate({ variant }) {

  const [data, setData] = React.useState([]);
  const [memInput, setMemInput] = React.useState("");
  const [mem, setMem] = React.useState([]);
  const [loader, setLoader] = React.useState(false);

 

  // ---- API / MOCK HANDLER ----
  const getApi = async () => {
    setLoader(true);
    try {
      // future API
      const response = await allCorporateList();
      setData(response?.data);
      setMem(response?.data);
    } catch (error) {
      setData([]);
      setMem([]);
      axiosErrorHandler(error);
    } finally {
      setLoader(false);
    }
  };

  // ---- SEARCH ----
  const handleSearch = (e) => {
    const value = e.target.value.trimLeft().toLowerCase();
    setMemInput(value);

    if (value === "") {
      setData(mem);
      return;
    }

    const filterData = mem.filter((item) =>
      item.name.toLowerCase().includes(value)
    );

    setData(filterData);
  };

  React.useEffect(() => {
    getApi();
  }, []);

  const breadcrumbs = [
    { name: "Dashboard", link: "/" },
    { name: "All Scenarios",  },
  ];

  return (
    <Stack>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <LoaderImg />
        <CircularProgress color="inherit" />
      </Backdrop>

      <BreadCrumbs breadcrumbs={breadcrumbs} />

      <Box style={{ width: "100%", padding: 40 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h2">All Scenarios</Typography>

          <SearchBar
            value={memInput}
            placeholder="Search"
            onChange={handleSearch}
          />
        </Stack>

        <TransitionGroup style={{ marginTop: 20 }}>
          {data?.length > 0 &&
            data.map((item, index) => (
              <Collapse in={true} key={`${index}-${item?.id}`}>
                <CorporateCategoryCardList
                  item={item}
                  variant={variant}
                  loader={loader}
                  setLoader={setLoader}
                />
              </Collapse>
            ))}
        </TransitionGroup>

        {data?.length === 0 && (
          <Typography
            variant="h3"
            sx={{ textAlign: "center", mt: "50px" }}
          >
            No result found
          </Typography>
        )}
      </Box>
    </Stack>
  );
}